import { createQuery } from './core';
// PUBLIC API
export const getEmailByUsername = createQuery('operations/get-email-by-username', ['User']);
// PUBLIC API
export const getAuthIdentity = createQuery('operations/get-auth-identity', ['User']);
// PUBLIC API
export const checkAuthSecurity = createQuery('operations/check-auth-security', ['User']);
// PUBLIC API
export const validatePassword = createQuery('operations/validate-password', []);
// PUBLIC API
export const getAuthStatus = createQuery('operations/get-auth-status', []);
// PUBLIC API
export const getProfileInsights = createQuery('operations/get-profile-insights', ['User']);
// PUBLIC API
export const getProfileInsightsEnvelope = createQuery('operations/get-profile-insights-envelope', ['User']);
// PUBLIC API
export const getUserPreferences = createQuery('operations/get-user-preferences', ['User', 'UserPreferencePattern']);
// PUBLIC API
export const getSwipeAnalytics = createQuery('operations/get-swipe-analytics', ['SwipeEvent', 'UserPreferencePattern']);
// PUBLIC API
export const getDemoPlan = createQuery('operations/get-demo-plan', ['User']);
// PUBLIC API
export const getUserTasteProfile = createQuery('operations/get-user-taste-profile', ['User', 'UserTasteProfile']);
// PUBLIC API
export const getPlanMetrics = createQuery('operations/get-plan-metrics', ['User']);
// PUBLIC API
export const getDiscoverRecipes = createQuery('operations/get-discover-recipes', ['User', 'UserTasteProfile', 'Recipe']);
// PUBLIC API
export const getShoppingList = createQuery('operations/get-shopping-list', ['User', 'MealPlan', 'UserProfile']);
// PUBLIC API
export const getUserHouseholds = createQuery('operations/get-user-households', ['User', 'Household', 'HouseholdMember']);
// PUBLIC API
export const getHouseholdShoppingList = createQuery('operations/get-household-shopping-list', ['User', 'Household', 'HouseholdMember', 'ShoppingList']);
// PUBLIC API
export const getUserEquipment = createQuery('operations/get-user-equipment', ['User', 'KitchenEquipment']);
// PUBLIC API
export const getHouseholdDetails = createQuery('operations/get-household-details', ['User', 'Household', 'HouseholdMember']);
// PUBLIC API
export const getRetentionInsights = createQuery('operations/get-retention-insights', ['User', 'RetentionOffer', 'CancellationSurvey', 'UserEvent']);
// PUBLIC API
export const getTasks = createQuery('operations/get-tasks', ['Task', 'Tag']);
// PUBLIC API
export const getTags = createQuery('operations/get-tags', ['Tag']);
// PUBLIC API
export const getUserProfile = createQuery('operations/get-user-profile', ['User', 'UserProfile']);
// PUBLIC API
export const getCurrentMealPlan = createQuery('operations/get-current-meal-plan', ['User', 'MealPlan']);
// PUBLIC API
export const getUserMealPlans = createQuery('operations/get-user-meal-plans', ['User', 'MealPlan']);
// PUBLIC API
export const getCustomRecipes = createQuery('operations/get-custom-recipes', ['User', 'UserRecipe']);
// PUBLIC API
export const getMealPlanById = createQuery('operations/get-meal-plan-by-id', ['User', 'MealPlan']);
// PUBLIC API
export const getSwipeHistory = createQuery('operations/get-swipe-history', ['User', 'UserEvent']);
// PUBLIC API
export const getPersonalizationInsights = createQuery('operations/get-personalization-insights', ['User', 'PersonalizationInsights']);
// PUBLIC API
export const getPersonalizedRecipes = createQuery('operations/get-personalized-recipes', ['User', 'UserProfile', 'Recipe', 'PersonalizationInsight', 'RecipeMetricsDaily']);
// PUBLIC API
export const getPersonalizedRecipesV2 = createQuery('operations/get-personalized-recipes-v2', ['User', 'Recipe']);
// PUBLIC API
export const getPersonalizedRecipesV2Page = createQuery('operations/get-personalized-recipes-v2-page', ['User', 'Recipe']);
// PUBLIC API
export const getPersonalizedSnapshots = createQuery('operations/get-personalized-snapshots', ['User', 'RecipeSnapshot']);
// PUBLIC API
export const searchRecipes = createQuery('operations/search-recipes', []);
// PUBLIC API
export const semanticSearch = createQuery('operations/semantic-search', ['Recipe', 'RecipeMetricsDaily', 'UserEvent', 'User', 'UserProfile']);
// PUBLIC API
export const getAdminEventsSummary = createQuery('operations/get-admin-events-summary', ['UserEvent']);
// PUBLIC API
export const getFeatureFlags = createQuery('operations/get-feature-flags', ['FeatureFlag']);
// PUBLIC API
export const getIngredientUnitsToFix = createQuery('operations/get-ingredient-units-to-fix', ['RecipeIngredient', 'Ingredient', 'Recipe']);
// PUBLIC API
export const getBillingSummary = createQuery('operations/get-billing-summary', ['User', 'Subscription', 'Payment', 'UserEvent']);
// PUBLIC API
export const getRetentionEligibility = createQuery('operations/get-retention-eligibility', ['User', 'RetentionOffer', 'CancellationSurvey', 'SubscriptionPause']);
// PUBLIC API
export const getUsageStatus = createQuery('operations/get-usage-status', ['User', 'UsageTracking']);
// PUBLIC API
export const getCurrentMealPlanV3 = createQuery('operations/get-current-meal-plan-v3', ['User', 'MealPlan']);
// PUBLIC API
export const getRecipe = createQuery('operations/get-recipe', []);
// PUBLIC API
export const getRecipeForCooking = createQuery('operations/get-recipe-for-cooking', []);
// PUBLIC API
export const getRecipeManagerData = createQuery('operations/get-recipe-manager-data', ['User', 'Recipe', 'RecipeIngredient', 'RecipeStep', 'UserRecipe', 'UserSavedRecipe']);
// PUBLIC API
export const getSharedRecipe = createQuery('operations/get-shared-recipe', ['User', 'Recipe', 'RecipeIngredient', 'RecipeStep', 'UserSavedRecipe']);
// PUBLIC API
export const getShoppingListWithItems = createQuery('operations/get-shopping-list-with-items', ['User', 'ShoppingList', 'ShoppingListItem', 'Ingredient', 'StoreSection']);
// PUBLIC API
export const getAdminMetrics = createQuery('operations/get-admin-metrics', ['User', 'Subscription', 'Payment', 'UserEvent', 'AiEvent', 'MetricDaily']);
// PUBLIC API
export const getCommunityBenchmarks = createQuery('operations/get-community-benchmarks', ['User', 'MealPlan', 'UserProfile']);
// PUBLIC API
export const getExportHistory = createQuery('operations/get-export-history', ['User', 'ExportHistory']);
// PUBLIC API
export const getAdminOverview = createQuery('operations/get-admin-overview', ['User', 'Subscription', 'UserEvent']);
// PUBLIC API
export const getAdminRevenue = createQuery('operations/get-admin-revenue', ['User', 'Subscription']);
// PUBLIC API
export const getCacheStats = createQuery('operations/get-cache-stats', []);
// PUBLIC API
export const getAvgPlanCost = createQuery('operations/get-avg-plan-cost', ['MealPlan']);
// PUBLIC API
export const getAvgPlanCostByRegion = createQuery('operations/get-avg-plan-cost-by-region', ['MealPlan', 'User', 'UserProfile']);
// PUBLIC API
export const getClientFlags = createQuery('operations/get-client-flags', []);
// PUBLIC API
export const getAdminAlerts = createQuery('operations/get-admin-alerts', ['UserEvent']);
// PUBLIC API
export const getAdminBillingMetrics = createQuery('operations/get-admin-billing-metrics', ['User', 'Subscription', 'Payment', 'UserEvent', 'AiEvent']);
// PUBLIC API
export const assertAdmin = createQuery('operations/assert-admin', []);
// PUBLIC API
export const getSemanticDiscoveryMetrics = createQuery('operations/get-semantic-discovery-metrics', ['User', 'Recipe', 'AuditLog']);
// PUBLIC API
export const getSystemHealthMetrics = createQuery('operations/get-system-health-metrics', ['User']);
// PUBLIC API
export const getTasteProfileStatusAdmin = createQuery('operations/get-taste-profile-status-admin', ['User', 'UserTasteProfile']);
// PUBLIC API
export const getSpoonacularStatus = createQuery('operations/get-spoonacular-status', ['User']);
// PUBLIC API
export const getUserNavPreferences = createQuery('operations/get-user-nav-preferences', ['User']);
// PUBLIC API
export const getFavorites = createQuery('operations/get-favorites', ['UserSavedRecipe', 'Recipe']);
// PUBLIC API
export const getFavoritesByOrigin = createQuery('operations/get-favorites-by-origin', ['UserSavedRecipe', 'Recipe']);
// PUBLIC API
export const getScrapedRecipes = createQuery('operations/get-scraped-recipes', ['ScrapedRecipe', 'User']);
// PUBLIC API
export const getBetaWaitlistEntries = createQuery('operations/get-beta-waitlist-entries', ['BetaWaitlist', 'User']);
// PUBLIC API
export const getBetaWaitlistStats = createQuery('operations/get-beta-waitlist-stats', ['BetaWaitlist']);
// PRIVATE API (used in SDK)
export { buildAndRegisterQuery } from './core';
//# sourceMappingURL=index.js.map